// import React from 'react'
// import { MapContainer, TileLayer, useMap,Popup,Marker } from 'react-leaflet'
// import L from 'leaflet'; 
// import Auto from '../../assets/images/dashboard/auto.png'

// function MapView(props) {

//     console.log("DriversData in mapView",props.driversData)

//     const customIcon = L.icon({
//         iconUrl: Auto, // Path to the auto icon image
//         iconSize: [50, 50], // Size of the icon
//         iconAnchor: [25, 50], // Anchor point of the icon (middle bottom)
//     });

    
   
//     return (
        
//         <MapContainer
//         center={[15.2689, 76.3909]}
//         zoom={13}
//         style={{ height: '300px', width: '100%' }}
//         scrollWheelZoom={false}
//       >
//         <TileLayer
//           url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//           attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
//         />
        
//          {props.driversData.
//          filter(driver => driver.is_online).
//          map(driver => (
//              driver.current_location && driver.current_location.latitude && driver.current_location.longitude && (
//                 <Marker
//                     key={driver._id} // Assuming _id is unique for each driver
//                     position={[driver.current_location.latitude, driver.current_location.longitude]}
//                     icon={customIcon}
//                >
//                     <Popup>
//                         <div>
//                             <img src={driver.avatar_url} alt="Avatar" style={{ width: '50px', height: '50px' }} />
//                             <p>{driver.first_name} {driver.last_name}</p>
//                             <p>Vehicle Type: {driver.vehicle_type}</p>
//                         </div>
//                     </Popup>
//                 </Marker>)
//             ))}
  
//       </MapContainer>
     
//       );
// }

// export default MapView

import React from 'react';
import { MapContainer, TileLayer, Popup, Marker } from 'react-leaflet';
import L from 'leaflet'; 
import  Taxi from '../../assets/images/dashboard/Taxi.png';
import Auto from '../../assets/images/dashboard/auto_front.png';
// import Truck from '../../assets/images/dashboard/truck.png';

function MapView(props) {
  console.log("DriversData in mapView", props.driversData);

  // Define a mapping of service types to icons
  const serviceIcons = {
    Auto: L.icon({
      iconUrl: Auto,
      iconSize: [30, 30],
      iconAnchor: [25, 50],
    }),
    TourPackage: L.icon({
      iconUrl: Taxi,
      iconSize: [50, 50],
      iconAnchor: [25, 50],
    }),
    // truck: L.icon({
    //   iconUrl: Truck,
    //   iconSize: [50, 50],
    //   iconAnchor: [25, 50],
    // }),
  };

  return (
    <MapContainer
      center={[15.2689, 76.3909]}
      zoom={13}
      style={{ height: '300px', width: '100%' }}
      scrollWheelZoom={false}
    >
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />

      {props.driversData
        .filter(driver => driver.is_online)
        .map(driver => (
          driver.current_location &&
          driver.current_location.latitude &&
          driver.current_location.longitude && (
            <Marker
              key={driver._id} // Assuming _id is unique for each driver
              position={[driver.current_location.latitude, driver.current_location.longitude]}
              icon={serviceIcons[driver.serviceAssociated] || serviceIcons.auto} // Default to auto if no match
            >
              <Popup>
                <div>
                  <img
                    src={driver.avatar_url}
                    alt="Avatar"
                    style={{ width: '50px', height: '50px', borderRadius: '50%' }}
                  />
                  <p>
                    {driver.first_name} {driver.last_name}
                  </p>
                  <p>Vehicle Type: {driver.vehicle_type}</p>
                  <p>Service: {driver.serviceAssociated}</p>
                </div>
              </Popup>
            </Marker>
          )
        ))}
    </MapContainer>
  );
}

export default MapView;
